import { render } from "./SettingsQuestion.vue?vue&type=template&id=55a08dfc"
import script from "./SettingsQuestion.vue?vue&type=script&lang=ts"
export * from "./SettingsQuestion.vue?vue&type=script&lang=ts"
script.render = render

export default script